import { Box, InputLabel, MenuItem, Select } from '@mui/material'
import { SystemBannerPlatformTypes } from '../types'
import { useFormContext } from 'react-hook-form'

export const PlatformSelect = () => {
  const { register } = useFormContext()

  const displayType = (type: string) => {
    if (type === 'PatronApp') {
      return 'Patron App'
    } else if (type === 'JJConnect') {
      return 'J&J Connect'
    }
  }

  return (
    <Box>
      <InputLabel htmlFor={'platform'} required>
        Select Platform
      </InputLabel>

      <Select
        {...register('platformType')}
        labelId={'platform'}
        variant="outlined"
        defaultValue=""
        fullWidth
        inputProps={{ id: 'platform' }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {SystemBannerPlatformTypes.map((type) => (
          <MenuItem value={type} key={type}>
            {displayType(type)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
